const configApp = {
    concept: {
        channel: 'CHANNEL',
        currency: 'CURRENCY',
        channelTransaction: 'CHANNEL_TRANSACTION',
        documentType: 'DOCUMENT_TYPE',
        documentTypePayment: 'TIPO_RECAUDACION',
        typePayment: 'TIPO_PAGO',
        typeMessage: 'MESSAGE',
        statusPayment: 'STATUS_PAYMENT',
        statusCustomer: 'STATUS_CUSTOMER',
        openDocumentType: 'TIPO_DOCUMENTO',
        conciliationOpenDocType: 'CONCILIATION_OPEN_DOCUMENT',
        environment: 'ENVIRONMENT',
        customerType: 'CUSTOMER_TYPE',
        statusDocument: 'STATUS_DOCUMENT'
    },
    type: {
        inProgress:'PY1',
        sendPayment: 'PY8',
        summaryDetail: 'COD2',//tipos de reporte
        summaryGlobal: 'COD1',
        summaryOpenDocumentByClient: 'COD3',
        typeClientRegular:'01',
        typeClientBodega:'02'
    },
    action:{
        add:'ADD',
        edit:'UPDATE',
        list:'VIEW',
        delete:'DELETE',
        client:'CLIENT',
        seller:'SELLER'
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    configApp
};